// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'typeface-roboto'
import '@babel/polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import './assets/css/tailwind.css'
import './assets/css/common.css'

import 'autotrack'
window.ga('create', 'UA-25427680-32', 'auto')
window.ga('require', 'outboundLinkTracker')
window.ga('require', 'mediaQueryTracker')
window.ga('require', 'eventTracker')
window.ga('require', 'ec')

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  if (to.fullPath.substr(0, 2) === '/#') {
    const path = to.fullPath.substr(2)
    next(path)
    return
  }

  next()
})

// router.afterEach((to, from) => {

// })

router.afterEach((to, from) => {
  window.ga('set', 'page', to.path)
  window.ga('send', 'pageview')
})

Vue.use(Vuex)



// WEBPACK FOOTER //
// ./src/main.js